import axios from "./axios";

/**
 * Privileged Layer C diagnostics (PlatformOps::Access on server).
 * Never store the response in Redux — component-local / ephemeral only.
 *
 * @param {string} requestId
 * @returns {Promise<{ success: boolean, data?: object, errors?: string[], status: number }>}
 */
export async function fetchErrorDiagnostics(requestId) {
  const id = String(requestId || "").trim();
  if (!id) {
    return { success: false, errors: ["missing_request_id"], status: 400 };
  }

  try {
    const res = await axios.get(
      `/platform_ops/error_diagnostics/${encodeURIComponent(id)}`,
      {
        // Avoid shared HTTP caches for privileged payloads
        headers: { "Cache-Control": "no-cache" },
      }
    );
    return {
      success: Boolean(res.data?.success),
      data: res.data?.data || null,
      status: res.status,
    };
  } catch (err) {
    const status = err?.response?.status || 0;
    const errors = err?.response?.data?.errors;
    return {
      success: false,
      data: null,
      errors: Array.isArray(errors) ? errors : undefined,
      status,
    };
  }
}

/** Probe whether the current session has platform-ops access (server truth). */
export async function fetchPlatformOpsSession() {
  try {
    const res = await axios.get("/platform_ops/session");
    return {
      allowed: Boolean(res.data?.success && res.data?.data?.platform_ops_access),
      status: res.status,
    };
  } catch (err) {
    return {
      allowed: false,
      status: err?.response?.status || 0,
    };
  }
}
